<template>
  <div class="c-input-select__wrap">
    <select
      :id="id"
      :name="name"
      :value="value"
      class="c-input-select"
      :class="[
        {
          'c-input-select--error': error
        },
        fontFamily ? `c-input-select--${fontFamily}` : ''
      ]"
      :style="{ color: color }"
      :error="error"
      @input="updateValue"
      @change="updateValue"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    >
      <option
        v-for="(option, key) in options"
        :key="key"
        :value="option.value"
        :selected="value === option.value"
      >
        {{ option.label }}
      </option>
    </select>

    <IconBase
      class="c-input-select__icon"
      :class="{
        'c-input-select__icon--error': error
      }"
      view-box="0 0 24 24"
      width="24"
      height="24"
    >
      <IconArrowBottom />
    </IconBase>
  </div>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  emits: ["input", "selected"],
  props: {
    id: { type: String, required: false },
    name: { type: String, required: true },
    value: { type: [String, Number], required: true },
    error: { type: String, required: false },
    options: { type: Array, required: true },
    color: { type: String, default: "" },
    fontFamily: { type: [String, Boolean], default: false }
  },
  components: {
    IconBase,
    IconArrowBottom
  }
})
export default class InputSelect extends Vue {
  id!: string;
  name!: string;
  value!: any;
  error!: string;
  options!: any;
  color!: string;
  fontFamily!: any;

  updateValue(e: any) {
    const selectedIndex = e.target.selectedIndex;
    const options = e.target.options;
    const value = options && options.length ? options[selectedIndex].value : "";
    this.$emit("input", value);
    this.$emit("selected", value);
  }
}
</script>

<style lang="scss" scoped>
.c-input-select {
  font-size: rem(14);
  line-height: normal;
  width: 100%;
  border: px(1) solid $common-gray-border;
  border-radius: px(4);
  padding: rem(10) rem(40) rem(11) rem(12);
  display: block;

  &::-ms-expand {
    display: none;
  }

  &--roboto {
    font-family: $font--roboto;
    font-weight: bold;
  }

  &--error {
    border-color: $error;
  }

  &:focus {
    border-color: $common-black;
  }

  &__wrap {
    position: relative;
  }
  &__icon {
    color: $common-gray500;
    position: absolute;
    right: px(12);
    top: 0;
    bottom: 0;
    width: px(24);
    height: px(24);
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;

    &--error {
      color: $error;
    }
  }
}
</style>
